import { useRef } from 'react';
import cn from 'classnames';

import Link from 'components/link/Link';
import NavigationList from './NavigationList';

import { INavigationGroup } from 'source/NFR.types';

interface NavigationGroupProps extends INavigationGroup {
  className?: string;
}

const NavigationGroup: React.FC<NavigationGroupProps> = ({ items = [], title, className }) => {
  const linkRefs = useRef<(HTMLLIElement | null)[]>([]);

  return (
    <div className={cn('navigation-group', className)}>
      {title && <h2>{title}</h2>}
      <ul>
        {items?.map(({ link, linkList }, index) => {
          if (link) {
            return (
              <li key={link.url + String(index)} ref={el => (linkRefs.current[index] = el)}>
                <Link {...link} theme={['white', 'fullWidth']} noHoverEffect />
              </li>
            );
          }

          if (linkList) {
            return (
              <li key={linkList.title + String(index)}>
                <NavigationList {...linkList} />
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );
};

NavigationGroup.displayName = 'NavigationGroup';

export default NavigationGroup;
